import { render, staticRenderFns } from "./TheViewDocumentModal.vue?vue&type=template&id=5643a0c0&"
import script from "./TheViewDocumentModal.vue?vue&type=script&lang=ts&"
export * from "./TheViewDocumentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports